// DEV, TEST, PROD
export const AMBIENTE = 'TEST';
